import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import "./Home.css";

const Home = () => {
  return (
    <div className="home-page">
      <SEO 
        title="Ultraze FA - Histoire Gaming | Serveur FiveM RP | ultraze.fr"
        description="Explorez l'univers de Ultraze FA et la création de SideLife. Un récit captivant de l'expérience FiveM RP et de la communauté gaming francophone. Découvrez l'évolution des serveurs GTA RP et les aventures dans l'univers virtuel."
        keywords="ultraze, ultraze fa, ultraze wl, ultrazewl, ultraze whitelist, shino, shinozatv, shinoza tiktok, fivem, gta rp, serveur fivem, roleplay gta, gta 5 rp, five m, gta v rp, rp français, serveur roleplay, communauté fivem, side life, sidelife fivem, blf fivem, histoire fivem, serveur gta v, fivem server, roleplay server, french rp, gta online rp, multiplayer rp, gaming community, virtual world, role playing game, grand theft auto v, fivem france, fivem communautaire, rp serious, rp réaliste, ville virtuelle, économie virtuelle, police rp, ambulance rp, criminalité rp, vie urbaine, simulation urbaine, serveur fivem français, communauté rp, projet fivem, développement serveur, gaming youtube, streamer fivem, créateur contenu gaming"
        url="/"
        image="/logo.png"
        type="website"
      />
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-logo">
            <img src={require('../logo.png')} alt="Ultraze FA Logo" />
          </div>
          <h1 className="hero-title">ULTRAZE <span className="highlight">FA</span></h1>
          <div className="hero-buttons">
            <Link to="/histoire" className="btn btn-primary">
              Explorer l'histoire
            </Link>
          </div>
        </div>
        <div className="hero-overlay"></div>
      </section>

      {/* Preview Sections */}
      <section className="preview-sections">
        <div className="container">
          <h2 className="section-title">EXPLORER <span className="highlight">L'HISTOIRE</span></h2>
          
          <div className="preview-grid">
            <div className="preview-card">
              <div className="preview-icon">
                <i className="fas fa-book-open"></i>
              </div>
              <h3>L'Histoire</h3>
              <p>
                Explorez un récit fictif dans l'univers FiveM, imaginant les projets, les collaborations 
                et les expériences qui pourraient façonner un cheminement virtuel.
              </p>
              <Link to="/histoire" className="btn btn-secondary">Explorer le récit</Link>
            </div>

            <div className="preview-card">
              <div className="preview-icon">
                <i className="fas fa-rocket"></i>
              </div>
              <h3>Perspectives Futures</h3>
              <p>
                Découvrez une vision fictive de SideLife, un projet imaginaire construit sur 
                des principes humains et une orientation renouvelée dans l'univers virtuel.
              </p>
              <Link to="/avenir" className="btn btn-secondary">Explorer</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Discord Invitation Section */}
      <section className="discord-invite">
        <div className="container">
          <div className="discord-content">
            <div className="discord-icon">
              <i className="fab fa-discord"></i>
            </div>
            <h2 className="discord-title">Rejoignez la Communauté <span className="highlight">SideLife</span></h2>
            <p className="discord-description">
              Découvrez le futur du RP FiveM avec notre communauté grandissante. 
              Échangez, participez et faites partie de l'aventure SideLife.
            </p>
            <a 
              href="https://discord.gg/ZQh79htaUf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-discord"
            >
              <i className="fab fa-discord"></i>
              Rejoindre le Discord
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;